<h2 class="text-2xl font-bold p-4">Gestisci Teams</h2>

<app-entity-crud-page-template
  [data]="teams"
  [columns]="columns"
  [loading]="loading"
  [totalRecords]="totalRecords"
  [rows]="rows"
  (onLazyLoad)="loadTeams($event)"
  (onCreate)="saveTeam()"
  (onDeleteSelected)="deleteSelectedTeams($event)"
  [enableSearch]="false"
  [enableFilterReset]="true"
/>
